module.exports = __webpack_public_path__ + "static/invBtn.5f8e5a86.png";